/**
 * DocumentBrandHeader Component
 *
 * Co-branded document header: organization (co-brand) logo + name +
 * system subtitle as the primary header, followed by the document title.
 * Visible on screen and in print (used by the *Print preview pages).
 *
 * Usage:
 *   <DocumentBrandHeader title="WORK ORDER" />
 */

import { Box, Typography } from '@mui/material'
import { useBranding } from '@context/BrandingContext'

const DocumentBrandHeader = ({ title, subtitle }) => {
  const { orgName, orgLogoUrl, systemSubtitle } = useBranding()

  return (
    <Box sx={{ textAlign: 'center', mb: 3 }}>
      {orgLogoUrl && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
          <img src={orgLogoUrl} alt={orgName} style={{ height: '70px' }} />
        </Box>
      )}
      <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#212B36' }}>
        {orgName}
      </Typography>
      <Typography
        variant="h6"
        sx={{
          fontWeight: 'bold',
          color: '#1B5E7A',
          letterSpacing: '0.5px',
          mb: 2,
        }}
      >
        {systemSubtitle}
      </Typography>
      {title && (
        <Typography variant="h6" sx={{ fontWeight: 'bold', textDecoration: 'underline' }}>
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography color="text.secondary" sx={{ mt: 1 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  )
}

export default DocumentBrandHeader
